/** Espelha ATS.Hub.Lib.DFe.Enums.TipoAmbienteEnum (id_tipo_ambiente). */
export enum TipoAmbienteEnum {
  Producao = 1,
  Homologacao = 2,
}
